import * as React from "react";
import { FormControl, Box } from "@mui/material";
import { StringUtils } from "../../util/StringUtils";
import parse from "html-react-parser";
import { htmlParseOptions } from "../../constants/htmlParseOptions";

const Content = (props: any) => {
  let { description, visible } = props;
  let showDescription = description !== undefined && description !== "";
  description = StringUtils.stripTags(description, StringUtils.allowedTags);

  return (
    <Box sx={{ display: visible ? "block" : "none" }}>
      <FormControl className="form-control" fullWidth={true}>
        {showDescription ? <div>{parse(description, htmlParseOptions)}</div> : null}
      </FormControl>
    </Box>
  );
};

export default Content;
